module.exports = "/src/views/player/help/images/mech.jpg";